import { PropsWithChildren } from 'react';

export const DeclineCaseSection = ({ children, heading }: { heading: string } & PropsWithChildren) => (
  <div className="flex flex-col gap-4">
    <div className="text-l-sb">{heading}</div>
    <div>{children}</div>
  </div>
);
